/* eslint-disable jsx-a11y/anchor-is-valid */
import * as React from 'react'
import * as classnames from 'classnames'

import { commaStyleString } from '../../../../common/utils/formatString'
import SearchLink from '../../../containers/searchLinkContainer'
import { IBlockMatchedComponent } from '../../../pages/category/category'

import { IFlatQuery } from '../../../../common/utils/location/types'

import * as styles from './categoriesWithCount.module.css'

interface ICategoryWithCountBlockData {
  name: string
  count: number
  urlSearchParams: IFlatQuery
}

interface IProps extends IBlockMatchedComponent {
  data: ICategoryWithCountBlockData[]
}

const CategoriesWithCount: React.SFC<IProps> = ({ data, locationParams }) => {
  const browseLinks = [
    { text: 'Newest', sort: 'date' },
    { text: 'All', sort: 'sales' }
  ]

  const rootClassNames = classnames(styles.root, {
    [styles.withSubcategories]: data.length > 0
  })

  return (
    <nav className={rootClassNames}>
      <div className={styles.browseAll}>
        Browse
        {browseLinks.map((link, index) => (
          <SearchLink
            key={index}
            locationParams={{
              category: locationParams.category,
              sort: link.sort
            }}
            className={styles.browseLink}
          >
            {link.text}
          </SearchLink>
        ))}
      </div>
      <div className={styles.categoryLinkWrapper}>
        {data.map((category, index) => (
          <SearchLink
            key={index}
            className={styles.categoryLink}
            locationParams={category.urlSearchParams}
          >
            {category.name} ({commaStyleString(category.count, ',')})
          </SearchLink>
        ))}
      </div>
    </nav>
  )
}

export default CategoriesWithCount
